/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {

};
export default getters;
